/**
 * interact.js 1.8.5
 *
 * Copyright (c) 2012-2020 Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
